import React, { Component } from "react";

export default class PrivacyStatement extends Component {
  render() {
    return (
      <div>
        <h6 class="privacy_subheading">Privacy Statement </h6>
        <div>
        This Privacy Statement is effective May 1, 2019.
        </div>
        <div class="privacy_paragraphh">
        netWell understands that when our clients, partners and other individuals provide personal data to us, they place their trust in us. We take this trust seriously and are committed to respecting each individual’s privacy and protecting the personal data we handle.
        </div>


        <h6 class="privacy_subheading">How We Collect And Use Personal Data</h6>
        <div class="privacy_paragraphh">
        We collect and use personal data that you provide in order to operate our business, provide our products and services, send marketing and other communications, and comply with applicable laws and regulations. In addition to the data you provide to us directly, we may also process personal data about you that we receive from our clients or third parties.
        </div>
        <div class="privacy_paragraphh">
        The types of personal data we process will depend on the purpose, including:
        </div>
        <div class="privacy_paragraphh">
        Provide products and services – contact details (such as name, email, address, company name, phone number and other information necessary) to provide services to our clients and our client’s customers, including providing product support updates;
        </div>
        <div class="privacy_paragraphh">
        Improve our products and services – contact details to conduct quality controls and evaluate the performance of our products and services, including conducting customer satisfaction surveys;
        </div>
        <div class="privacy_paragraphh">
        Conduct due diligence – contact details and publicly available information about financial or reputational status of a client or third party supplier/partner;
        </div>
        <div class="privacy_paragraphh">
        Generate sales and marketing leads – contact details, marketing preferences, publicly available social media information to maintain a client relationship management database and send relevant newsletters, solution updates, event notifications and other marketing communications;
        </div>
        <div class="privacy_paragraphh">
        Manage relationships with our clients, suppliers and partners – contact details and payment information in order to execute contracts, generate invoices and make payments; and
        </div>
        <div class="privacy_paragraphh">
        Respond to inquiries or requests for information – contact details for electronic communication.
        </div>
        <div class="privacy_paragraphh">
        When we receive personal data about you from our clients in order to provide our services, netWell processes the personal data as instructed by our clients and in accordance with our contractual obligations. Our clients are responsible for complying with regulations or laws regarding notice, disclosure, and/or obtaining consent prior to transferring the personal data to us for processing.
        </div>


        <h6 class="privacy_subheading">How We Protect Your Personal Data</h6>
        <div class="privacy_paragraphh">
        We use reasonable security procedures and technical and organizational measures to protect against accidental or unlawful destruction, loss, disclosure or use of personal data we handle. We limit access to and use of your personal data to authorized persons and trusted third parties who have a reasonable need to know the information in order to perform our services and business operations and who are bound by confidentiality obligations.
        </div>

        <h6 class="privacy_subheading">How Long We Retain Personal Data</h6>
        <div class="privacy_paragraphh">
        We retain your personal data only for as long as is necessary to fulfill the purpose for which the data was collected from you and in consideration of and compliance with applicable legal or regulatory requirements to maintain the data for legitimate purposes. For example, where required by law for audits or accounting requirements, to enforce our agreements or handle disputes. When personal data is no longer needed for the purpose it was collected or processed or to comply with a legal obligation, we securely destroy it.
        </div>

        <h6 class="privacy_subheading">How We Share Your Personal Data</h6>
        <div class="privacy_paragraphh">
        We do not sell or otherwise disclose personal data about our website visitors or others that interact with netWell or our products or services, except as described herein.
        </div>
        <div class="privacy_paragraphh">
        We may share your personal data with authorized netWell personnel with a need to know the information in order to process the personal data for the purpose we collected it. We also share personal data with third parties who are acting on our behalf in order to provide the products or services you request or to support our relationship with you. These third parties are not authorized by us to use or disclose the information except as necessary to perform services on our behalf pursuant to a contractual obligation or to comply with legal requirements. netWell requires such third parties to comply with applicable data protection and privacy laws and agree to implement and maintain appropriate technical and organizational security measures to safeguard the personal data.
        </div>
        <div class="privacy_paragraphh">
        Our sharing may include:
        </div>
        <div class="privacy_paragraphh">
        With any of our netWell subsidiaries and trusted third party suppliers/partners in order to perform our services or business operations;
        </div>
        <div class="privacy_paragraphh">
        With our professional advisors and insurers to run our business;
        </div>
        <div class="privacy_paragraphh">
        With legal authorities, government agencies, law enforcement authorities or other government officials when required by applicable laws or regulations or or pursuant to legal process (including for national security purposes);when we believe disclosure is necessary or appropriate to prevent physical harm or financial loss or in connection with an investigation of suspected or actual fraud or illegal activity; or when we believe that disclosure is necessary to protect our rights, protect your safety or the safety of others;
        </div>
        <div class="privacy_paragraphh">
        With appropriate third parties in connection with the sale, transfer or financing of all or part of a netWell business or its assets, including any such activities associated with a bankruptcy proceeding.
        </div>
       

        <h6 class="privacy_subheading">How We Treat Personal Data From Individuals Outside The U.S.</h6>
        <div class="privacy_paragraphh">
        netWell is a U.S. enterprise based in the U.S. Our products, services, and offerings are only available to parties within the U.S., and may be subject to further geographic or other limitations within the U.S. While we cannot prevent individuals from outside the U.S. from providing contact information to netWell via our contact forms, we will not knowingly use information from parties outside the U.S., and will periodically purge any individual contact data known to be from individuals outside the U.S. from our databases.
        </div>


        <h6 class="privacy_subheading">How We Respect Your Privacy In Marketing</h6>
        <div class="privacy_paragraphh">
        netWell uses various means of communication and tools to market its products and services. We provide commercial marketing email to persons who consent or where we have a legitimate interest and it is otherwise permissible under applicable law. You may opt-out of our commercial marketing emails by using the “Unsubscribe” or “Opt-out” link in the commercial email or by contacting us at <span class="privacy_link_text">info@netwell.com.</span> 
        </div>
        <div class="privacy_paragraphh">
        We may strive to make your netWell experience the best it can be by using various tools that provide us with information about how you and other visitors interact with our website so that we can tailor your netWell experience and improve our web properties. These tools may include Cookies and other automatic data collection tools.
        </div>

        <h6 class="privacy_subheading">How To Request Access To Your Personal Data</h6>
        <div class="privacy_paragraphh">
        We rely on you to provide accurate, complete and current personal data to us.
        </div>
        <div class="privacy_paragraphh">
        If you need to correct or update the personal data you provided to us, we will respond in a timely manner to all reasonable requests to access, correct or delete your personal data. Requests and questions can be submitted to  <span class="privacy_link_text">info@netwell.com.</span>
            </div>


            <h6 class="privacy_subheading">How To Contact Us</h6>
        <div class="privacy_paragraphh">
        If you have any questions or comments regarding this statement or our privacy practices, or any concerns regarding a possible violation of this statement, our practices or any applicable privacy law please contact netWell at <span class="privacy_link_text">info@netwell.com</span> and we will promptly respond.
        </div>

        <h6 class="privacy_subheading">Our mailing address is:</h6>
        <div class="privacy_paragraphh">
        netWell, Inc.
        </div>
        <div class="privacy_paragraphh">
        Attn: Privacy Administrator
        </div>
        <div class="privacy_paragraphh">
        4555 Mansell Road, Suite 300,
        </div>
        <div class="privacy_paragraphh">
        </div>
        <div class="privacy_paragraphh">
        Alpharetta, GA 30022
        </div>
        <div class="privacy_paragraphh">
        United States
        </div>
        <div class="privacy_paragraphh">
        <a class="privacy_link_text " href="https://www.netwell.com/">www.netwell.com</a>
        </div>


        <h6 class="privacy_subheading">Links To Other Websites</h6>
        <div class="privacy_paragraphh">
        As a convenience to our website visitors, we sometimes provide links to other websites. These linked sites are not under the control of netWell and we are not responsible for their content. You should review the privacy statements of any linked website to understand their privacy practices before using the site.
        </div>

        <h6 class="privacy_subheading">Children</h6>
        <div class="privacy_paragraphh">
        It is not our intent to collect personal data from children under the age of consent. Our websites are not designed to attract children and we request that children under the age of consent not submit personal data to us through our websites.
        </div>

        <h6 class="privacy_subheading">Updates To Our Privacy Statement</h6>
        <div class="privacy_paragraphh">
        We may update this Privacy Statement from time to time. When we update this statement, we will also update the date at the top. Only the current statement is effective, so please review it periodically.
        </div>

      </div>
    );
  }
}
